module.exports = __webpack_public_path__ + "ef9210c4abde734c0dd199213fd5dc61.svg";